module.exports = __webpack_public_path__ + "images/emoji/envelope_with_arrow.859910f73e389e8764b4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/envelope_with_arrow.png
// module id = b9hm
// module chunks = 13